var React = require('react');

function OpenedIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"23","height":"15","x":".5","y":".5","fill":"#DFF0D8","stroke":"#D6E9C6","rx":"3","key":0}),React.createElement("polygon",{"fill":"#3C763D","points":"1.607 3.646 .9 4.354 3.3 6.754 7.148 1.807 6.359 1.193 3.207 5.246","transform":"translate(4 4)","key":1}),React.createElement("polygon",{"fill":"#3C763D","points":"1.607 3.646 .9 4.354 3.3 6.754 7.148 1.807 6.359 1.193 3.207 5.246","transform":"translate(12 4)","key":2})]));
}

OpenedIcon.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16"};

module.exports = OpenedIcon;

OpenedIcon.default = OpenedIcon;
